import { Device_State } from './enums';
import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'WaterTurbidity';

export type WaterTurbidityProps = {
  purpose?: string;
  sensorModel?: string;
  turbidityLevel?: number;
  waterTemperature?: number;
  state?: Device_State;
  location?: Position;
  image?: string;
};

export class WaterTurbidity extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purpose?: string;
  sensorModel?: string;
  turbidityLevel?: number;
  waterTemperature?: number;
  state?: Device_State;
  location?: Position;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of Water Quality Turbidity measurement point' },
      purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Measurement purpose' },
      sensorModel: { type: 'String', editable: true, label: 'Sensor model', name: 'sensorModel', description: 'Model of Turbidity Sensor and Sensor details' },
      turbidityLevel: { type: 'Number', editable: true, label: 'Turbidity Level', name: 'turbidityLevel', description: 'Turbidity Level - tbc' },
      waterTemperature: {
        type: 'Number',
        editable: true,
        label: 'Water Temperature',
        name: 'waterTemperature',
        description: 'Water Temperature - degrees Celsius',
      },
      state: {
        type: 'Enum',
        editable: true,
        label: 'State',
        name: 'state',
        description: 'State of mechanism - operational, requires maintenance etc',
        enumKv: Device_State,
      },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Location of  Water Quality Turbidity (lat/ long)' },
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of Water Quality Turbidity in situ' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
